module.exports = __webpack_public_path__ + "img/bg_1.9a87a1f5.svg";